import Vue from "vue";

export function useThrottle(options) {
  const { duration = 150, cacheKey, enableCache = true } = options;

  if (!cacheKey) {
    throw new Error("[useThrottle] cacheKey is required");
  }

  const state = Vue.observable({
    isCooling: false,
    remainingSeconds: 0
  });

  let timer = null;

  const clearTimer = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const stopCooling = () => {
    state.isCooling = false;
    state.remainingSeconds = 0;
    clearTimer();
    if (enableCache) {
      localStorage.removeItem(cacheKey);
    }
  };

  const startCooling = (seconds = duration) => {
    stopCooling();
    state.isCooling = true;
    state.remainingSeconds = seconds;
    if (state.remainingSeconds <= 0) {
      stopCooling();
      return;
    }
    timer = setInterval(() => {
      if (state.remainingSeconds <= 1) {
        stopCooling();
      } else {
        state.remainingSeconds--;
      }
    }, 1000);
  };

  const saveToCache = () => {
    if (!enableCache) return;
    localStorage.setItem(cacheKey, (Date.now() + duration * 1000).toString());
  };

  const restoreFromCache = () => {
    if (!enableCache) return;
    const expireTime = localStorage.getItem(cacheKey);
    if (!expireTime) return;
    const remaining = Math.ceil((parseInt(expireTime) - Date.now()) / 1000);
    if (remaining > 0) {
      startCooling(remaining);
    } else {
      localStorage.removeItem(cacheKey);
    }
  };

  const handleClick = callback => {
    if (state.isCooling) return;
    startCooling(duration);
    saveToCache();
    if (typeof callback === "function") callback(); // 增加类型检查
  };

  const resetCooling = () => {
    stopCooling();
  };

  restoreFromCache();

  return {
    isCooling: () => state.isCooling,
    remainingSeconds: () => state.remainingSeconds,
    handleClick,
    resetCooling,
    get state() {
      return state;
    }
  };
}
